import axios from 'axios';

const API_BASE_URL = 'https://tradebot-k4nt.onrender.com/api';
// eslint-disable-next-line no-unused-vars
const API_MAIN_URL = 'https://tradebot-k4nt.onrender.com';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

// API Service
export const apiService = {
  // Authentication
  login: (username, pin) => 
    apiClient.post('/login', { telegrameUsername: username, pin }),
  
  signup: (username, pin, email) => 
    apiClient.post('/signup', { telegrameUsername: username, pin, email }),
  
  googleLogin: (username, email) => 
    apiClient.post('/google-log', { telegrameUsername: username, email, pin: '' }),

  // User Operations
  getUserInfo: (username) => 
    apiClient.get(`/user/${username}`),
  
  checkUsername: (username) => 
    apiClient.get(`/user/check/${username}`),
  
  updatePin: (username, oldpin, pin) => 
    apiClient.post('/payment/updatePin/web', { username, oldpin, pin }),

  // Transactions
  sendMoney: (fromUsername, toUsername, amount, pin) => 
    apiClient.post('/send', { fromUsername, toUsername, amount, pin }),
  
  sendWalletID: (fromUsername, walletID, amount, cryptoType, pin) => 
    apiClient.post('/send-wallet', { fromUsername, walletID, amount, cryptoType, pin }),
  
  withdraw: (username, amount, accountNumber, bankName, accountName, pin) => 
    apiClient.post('/withdraw', { username, amount, accountNumber, bankName, accountName, pin }),
  
  withdrawCard: (username, amount, cardNumber, cvv, expiryDate, pin) => 
    apiClient.post('/withdraw-card', { username, amount, cardNumber, cvv, expiryDate, pin }),

  // Investment
  invest: (username, amount, plan) => 
    apiClient.post('/invest', { username, amount, plan }),
  
  getInvestments: (username) => 
    apiClient.get(`/investments/${username}`),

  // History
  getTransactionHistory: (username) => 
    apiClient.get(`/history/${username}`),

  // Referral
  getReferralInfo: (username) => 
    apiClient.get(`/referral/${username}`),
};

export default apiService;
